<template>
  <div>
    <v-toolbar color="primary">
      <v-toolbar-title class="ml-0 pl-3 white--text" style>
        <strong>
          <span style="font-size:1.2rem;">{{ getSelectedVisa.type }} Application</span>
        </strong>
      </v-toolbar-title>
    </v-toolbar>
    <v-card class="ma-2 px-5" white>
      <v-card-text>
        <v-layout wrap>
          <v-form class="pt-2" lazy-validation ref="form" row wrap>
            <v-layout row>
              <header-text
                  :text="$vuetify.lang.t('$vuetify.personal_information')"
                  icon="mdi-account"
              />
<!--              <v-flex xs12>-->
<!--                <div v-if="apply_type === 'eta'">-->
<!--                  <v-alert class="mb-6" outlined type="info" color="cyan darken-2">-->
<!--                    The international payment facility is currently unavailable and will be provisioned in the near future. In the meantime, please pay the visa fee through any bank or wallet service in Nepal.-->
<!--                  </v-alert>-->
<!--                </div>-->
<!--              </v-flex>-->
              <v-flex md4 xs12>
                <v-text-field
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    :label="$vuetify.lang.t('$vuetify.full_name')+' *'"
                    :rules="[rules.required,rules.alphaSpace]"
                    id="fullName"
                    outlined
                    type="text"
                    placeholder="Enter your first, middle, and last name"
                    v-model="visa.traveller.full_name"
                />
              </v-flex>

              <v-flex md4 xs12>
                <v-text-field
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    :label="$vuetify.lang.t('$vuetify.country')+' *'"
                    :rules="[rules.required]"
                    :value="currentCountryName"
                    id="country"
                    outlined
                    readonly
                />
              </v-flex>
              <v-flex md4 xs12>
                <v-select
                    :items="genders"
                    :label="$vuetify.lang.t('$vuetify.gender')+' *'"
                    :rules="[rules.required]"
                    id="gender"
                    outlined
                    v-model="visa.traveller.gender"
                />
              </v-flex>

              <v-flex class="pl-3  pr-3 " md4 sm12 xs12
              >
                <date-picker-new
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    :label="$vuetify.lang.t('$vuetify.dob_day')+ ' *'"
                    v-model="visa.traveller.dob"
                    :min-year="dob.min_year"
                    :max-year="dob.max_year"
                />
              </v-flex>
              <v-flex md4 xs12>
                <v-combobox
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    :items="occupationList"
                    :label="$vuetify.lang.t('$vuetify.occupation')+' *'"
                    :rules="[rules.required]"
                    id="occupation"
                    outlined
                    v-model="visa.traveller.occupation"
                />
              </v-flex>

              <v-flex md4 xs12>
                <address-auto-complete
                    :label="$vuetify.lang.t('$vuetify.address')+' of '+currentCountryName+' *'"
                    v-model="visa.traveller.full_address"
                    :rules="[rules.required]"
                />
              </v-flex>

              <v-flex md4 sm12 xs12>
                <v-text-field
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    :label="$vuetify.lang.t('$vuetify.contact_number')+ ' of '+currentCountryName+' *'"
                    :prefix="stdCode"
                    :rules="[rules.required, rules.international_number]"
                    min="0"
                    outlined
                    type="number"
                    v-model="visa.traveller.contact_number"
                    id="contactNumber"
                    onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
                />
              </v-flex>

              <v-flex md4 sm12 xs12>
                <v-text-field
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    :label="$vuetify.lang.t('$vuetify.email_required')"
                    :rules="[rules.required,rules.email]"
                    id="email"
                    outlined
                    placeholder="Application form will be sent to this email"
                    type="email"
                    v-model="visa.traveller.email"
                />
              </v-flex>
              <v-flex
                  md4
                  v-if="apply_type === 'online' || apply_type === 'eta'"
                  xs12
              >
                <file-input
                    :fileSize="6144"
                    :label="$vuetify.lang.t('$vuetify.passport_size_image')+' *'"
                    :required="true"
                    :valid_file_types="imageFileType"
                    id="userImage"
                    placeholder="JPEG, JPG or PNG only"
                    v-model="visa.traveller.traveller_image"
                />
              </v-flex>

              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex class="pl-3" md4 xs12>
                    <header-text
                        :text="visa.apply_with_traveller_document?$vuetify.lang.t('$vuetify.traveller_document_details'):$vuetify.lang.t('$vuetify.passport_details')"
                        icon="mdi-passport"
                    />
                  </v-flex>

                  <v-flex md4 v-if="show_apply_with_travel_document" xs12>
                    <v-checkbox
                        :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                        :value="1"
                        @change="clearPreviousDocument"
                        class="mt-0"
                        label="Apply with travel document"
                        v-model="visa.apply_with_traveller_document"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex md4 v-if="!visa.apply_with_traveller_document" xs12>
                <v-select
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    :items="passportTypesParsed()"
                    :label="$vuetify.lang.t('$vuetify.passport_type')+' *'"
                    :rules="[rules.required]"
                    id="passportType"
                    outlined
                    v-model="visa.passport.passport_type"
                />
              </v-flex>
              <v-flex md4 xs12>
                <v-text-field
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    :label="$vuetify.lang.t('$vuetify.passport_number')+' *'"
                    :rules="[rules.required]"
                    id="passportNumber"
                    outlined
                    type="text"
                    v-model="visa.passport.passport_number"
                />
              </v-flex>

              <v-flex class="pl-3" md4 v-if="!visa.apply_with_traveller_document" xs12>
                <date-picker-new :for-passport="1"
                                 :label="$vuetify.lang.t('$vuetify.passport_day')"
                                 v-model="visa.passport.validity"
                />
              </v-flex>
              <v-flex
                  :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                  md4
                  v-if="(apply_type === 'online' || apply_type === 'eta') && !visa.apply_with_traveller_document"
                  xs12
              >
                <file-input
                    :fileSize="6144"
                    :label="$vuetify.lang.t('$vuetify.passport_image')+' *'"
                    :required="true"
                    id="passportImage"
                    placeholder="JPEG, JPG, PNG, PDF or DOCX only"
                    v-model="visa.passport.passport_image"
                />
              </v-flex>
              <v-flex
                  :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                  md4
                  v-if="visa.apply_with_traveller_document"
                  xs12
              >
                <file-input
                    :fileSize="6144"
                    :label="$vuetify.lang.t('$vuetify.traveller_document')+' *'"
                    :required="true"
                    v-model="visa.traveller_document"
                />
              </v-flex>
<!--              <v-flex v-if="type !== 'diplomatic-visa' && type!=='official-visa'" xs12>-->
<!--                <Extra-Passport :visa_prop="visa"/>-->
<!--              </v-flex>-->
            </v-layout>
          </v-form>
          <v-spacer/>
          <v-card-actions style="padding: 0 0;">
            <v-btn
                @click="goBack"
                class="float-right"
                color="red darken-3"
                dark
                large
            >{{ $vuetify.lang.t('$vuetify.back') }}
            </v-btn>
            <v-btn
                v-if="apply_type !== 'eta'"
                :loading="loading"
                @click="proceed"
                class="float-right"
                color="blue darken-3"
                dark
                large
            >{{ $vuetify.lang.t('$vuetify.proceed') }}
            </v-btn>
          </v-card-actions>
        </v-layout>
      </v-card-text>
    </v-card>
      <v-dialog
          v-if="existingUnapprovedData && existingUnapprovedData.length > 0"
          v-model="showExistingUnapprovedDialog"
          persistent
          max-width="1100px"
          scrollable
      >
        <v-card elevation="8" v-if="existingUnapprovedData.length > 0">
          <v-card color="primary" dark elevation="4" class="mb-6">
            <v-card-text class="pa-6">
              <div class="d-flex justify-space-between align-center flex-wrap">
                <div class="d-flex align-center">
                  <v-avatar size="70" class="mr-4">
                    <v-img src="https://cdn01.immigration.gov.np/public/images/nepal_sarkar.png" alt="Emblem of Nepal" />
                  </v-avatar>
                  <div>
                    <div class="text-h6 font-weight-bold">Department of Immigration, Nepal</div>
                    <div class="text-subtitle-1" v-if="apply_type == 'online' || apply_type == 'arrival'">(Visa On Arrival)</div>
                    <div class="text-subtitle-1" v-if="apply_type == 'eta'">(Eta Application)</div>
                  </div>
                </div>
                <div class="text-right d-none d-md-block">
                  <div>Kalikasthan, Dillibazar, Kathmandu</div>
                  <div>Phone: +977-01-4429659, 4429660</div>
                  <div>info@immigration.gov.np</div>
                </div>
              </div>
            </v-card-text>
          </v-card>

          <v-card-text class="text-center py-8">
            <v-icon color="orange" size="60" class="mb-4">mdi-alert</v-icon>
            <div class="text-h5 font-weight-bold primary--text mb-2">
              You already have {{ existingUnapprovedData.length }} pending visa application{{ existingUnapprovedData.length > 1 ? 's' : '' }}
            </div>
            <div class="text-body-1 grey--text text--darken-1">
              Submitted within the last 7 days · Do you want to proceed with a new submission?
            </div>
          </v-card-text>

          <v-divider />

          <v-card-text>
            <v-simple-table class="elevation-2">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">Submission ID</th>
                  <th class="text-left">Full Name</th>
                  <th class="text-left">Date of Birth</th>
                  <th class="text-left">Nationality</th>
                  <th class="text-left">Passport No.</th>
                  <th class="text-left">Passport Expiry</th>
                  <th class="text-left">Applied On</th>
                  <th class="text-left">Voucher No.</th>
                  <th class="text-center">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(visit, index) in existingUnapprovedData" :key="visit.id || index">
                  <td>{{ visit.submission_no || 'N/A' }}</td>
                  <td>{{ visit.traveller ? visit.traveller.full_name : '-' }}</td>
                  <td>{{ visit.traveller ? visit.traveller.dob : '-' }}</td>
                  <td>{{ visit.traveller ? visit.traveller.country_name : '-' }}</td>
                  <td>{{ visit.passport_document ? visit.passport_document.document_number : '-' }}</td>
                  <td>{{ visit.passport_document ? visit.passport_document.validity : '-' }}</td>
                  <td>{{ visit.created_at || '-' }}</td>
                  <td>{{ visit.voucher_number || 'Not generated' }}</td>
                  <td class="text-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-on="on"
                            v-bind="attrs"
                            @click="redirectToDetail(visit)"
                            icon
                        >
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>View Details</span>
                    </v-tooltip>
                  </td>

                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>

          <v-card-actions class="justify-end pa-4" v-if="apply_type !== 'eta'">
            <v-btn
                color="primary"
                large
                @click="proceedAnyway()"
            >
              Proceed Anyway
            </v-btn>
          </v-card-actions>
          <v-alert v-else
              border="left"
              colored-border
              color="primary"
              elevation="2"
              class="mb-6 mt-4 portal-banner mx-6"
          >
            <div class="d-flex justify-space-between align-center flex-wrap">
              <div>
                <div class="text-h6 font-weight-bold">
                  New  Application Available
                </div>
              </div>

              <v-btn
                  class="mt-3 ml-3 mt-sm-0"
                  color="primary"
                  depressed
                  rounded
                  href="https://nepaliport-new.immigration.gov.np/eta-visa-processing/application"
                  target="_blank"
              >
                Visit New Application
                <v-icon right>mdi-open-in-new</v-icon>
              </v-btn>
            </div>
          </v-alert>
        </v-card>
      </v-dialog>

  </div>


</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AddressAutoComplete from "../../components/AddressAutoComplete";
import {validationMixin} from "../../mixins/validationMixin";
import FileInput from "../../components/FileInput";
import {passportTypes} from "../../constant/appConstant";
import HeaderText from "../../components/HeaderText";
import ExtraPassportDetail from "../../components/visa/ExtraPassportDetail";
import {fetchDynamicValues} from "../../helpers/dynamicValueHelper";
import DatePickerNew from "../../components/DatePickerNew";
import {API_URL, BASE_TOKEN, BASE_URL, VERSION} from "../../config/config";
import axios from "axios";
import {NEPAL_SARKAR_LOGO} from "../../constant/appConstant";


export default {
  data: () => ({
    dialog: false,
    imageFileType: ["png", "jpeg", "jpg"],
    passportSizeImage: {file: null, valid: true},
    genders: ["Male", "Female", "Others"],
    passportTypes,
    loading: false,
    occupationList: [],

    //newly added
    showExistingUnapprovedDialog: false,
    existingUnapprovedData: [],
    unapprovedTravellerMessage: "",
    unapprovedTravellerMalanikaSession: "",
    submitUnapprovedTraveller: false,
  }),
  props: {
    type: String,
  },
  mixins: [validationMixin],
  components: {
    DatePickerNew,
    "address-auto-complete": AddressAutoComplete,
    HeaderText,
    FileInput,
    "Extra-Passport": ExtraPassportDetail
  },
  methods: {
    ...mapActions({
      checkDocumentInformationValidation:
          "VisaSingle/checkDocumentInformationValidation",
      fetchConditionByVisaTypeSlug: "VisaType/fetchConditionByVisaTypeSlug",
      fetchVisaTypeCondition: "VisaType/fetchCondition",
      checkExistingUnapprovedVisa: "VisaSingle/checkExistingUnapprovedVisa",
      checkExistingEtaUnapprovedVisa: "VisaSingle/checkExistingEtaUnapprovedVisa"
    }),

    proceedAnyway(){
      this.showExistingUnapprovedDialog = false;
    },
    passportTypesParsed() {
      if (this.type === "diplomatic-visa") {
        return ["Diplomatic"];
      } else if (this.type === "official-visa") {
        return ["Official/Service"];
      } else {
        return this.passportTypes;
      }
    },

    async redirectToDetail(visit) {
      this.$router.push({
        name: "UnapprovedVisaApplicationPrint",
        params: {
          visit,
          unapprovedTravellerMessage: this.unapprovedTravellerMessage,
          unapprovedTravellerMalanikaSession: this.unapprovedTravellerMalanikaSession,
          submitUnapprovedTraveller: this.submitUnapprovedTraveller }
      });
    },

    async proceed() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let conditions = await this.fetchVisaTypeCondition();
        if (conditions.remaining_days === 0) {
          // this.loading = false;
          this.$store.commit(
              "Notification/showError",
              "Cannot proceed you don't have remaining days in current year"
          );
        } else {
          try {
            // let passport_year = this.visa.passport_validity.substr(0, 4);
            // passport_year = parseInt(passport_year);
            // let dob_year = this.visa.traveller.dob.substr(0, 4);
            // dob_year = parseInt(dob_year);
            // if ((dob_year + 10) <= passport_year) {
            //     this.$store.commit('Notification/showError', 'Invalid date of birth');
            //     return;
            // }

            if (!this.visa.apply_with_traveller_document) {
              await this.checkDocumentInformationValidation();
            }
            this.loading = false;

            this.$router.push({
              name: "SelectArrivalVisa",
              params: {
                office: this.office,
                apply: this.apply_type
              }
            });
          } catch (err) {
            this.loading = false;
            this.$store.commit('Notification/showError', err.response.data.errors[0])
          }
        }
      } else {
        this.$store.commit("Notification/showError", "Invalid form data");
      }
    },
    goBack() {
      let apply_type = this.$route.params.apply;
      let office = this.$route.params.office;
      if (apply_type === "arrival") {
        if (office === 'doi') {
          this.$router.push({
            name: 'EntryVisaProcessing'
          })
          return
        }
        this.$router.push({
          name: "OnArrival",
          params: {office}
        });
      } else {
        this.$router.push({
          name: "OnlineApplication"
        });
      }
    },
    clearPreviousDocument() {
      this.visa.passport.validity = null;
      this.visa.passport.passport_type = null;
      this.visa.traveller_document = null;
    }
  },
  beforeRouteEnter(to, from, next) {
    if (!from.name) {
      next(vm => {
        let apply_type = vm.$route.params.apply;
        let office = vm.$route.params.office;
        if (apply_type === "arrival") {
          if (office === 'doi') {
            vm.$router.push({
              name: 'ExtendChangeVisa'
            })
            return
          }
          vm.$router.push({
            name: "OnArrival",
            params: {office}
          });
        } else {
          vm.$router.push({
            name: "OnlineApplication"
          });
        }
      });
    }
    next();
  },
  async mounted() {
    fetchDynamicValues("occupations").then((data) => {
      this.occupationList = data;
    });
    this.$store.commit("VisaSingle/setApplyType", this.$route.params.apply);
    this.$store.commit("VisaSingle/setOffice", this.$route.params.office);
    this.visa.traveller.country = this.currentNationality;
    this.visa.passport.passport_type = this.countryCode !== "" ? this.passportTypes[0] : this.passportTypes[3];

    if (this.apply_type === 'arrival' || this.apply_type === 'online' || this.apply_type === 'eta') {
      try {
        let res;
        const inputData = {
          passport_number: this.visa.passport.passport_number,
          visa_type: this.getSelectedVisa.slug,
          apply_type: this.apply_type,
          dob: this.visa.traveller.dob,
          passport_type: this.visa.passport.passport_type,
          country: this.visa.traveller.country,
        };

        if (this.apply_type === 'eta') {
          res = await this.checkExistingEtaUnapprovedVisa(inputData);
        } else {
          res = await this.checkExistingUnapprovedVisa(inputData);
        }

        if (res && res.unapproved_visits && res.unapproved_visits.length > 0) {
          this.existingUnapprovedData = res.unapproved_visits;
          this.unapprovedTravellerMessage = res.message;
          this.unapprovedTravellerMalanikaSession = res.session_id;
          this.submitUnapprovedTraveller = res.not_allow_submission;
          this.showExistingUnapprovedDialog = true;
        }
      } catch (err) {
        console.error("Error checking existing unapproved visa:", err);
      }
    }

  },
  computed: {
    ...mapGetters("Notification", ["snackbar"]),
    ...mapGetters("VisaSingle", [
      "price",
      "occupationOptions",
      "apply_type",
      "office",
    ]),
    dob() {
      const max_year = parseInt(new Date().toISOString().substr(0, 4));
      const min_year = parseInt(max_year) - 120;
      return {
        min_year,
        max_year
      }
    },
    countryCode() {
      return (this.$store.state.CountryForTouristList.current.code.toLowerCase() !== 'un') ? this.$store.state.CountryForTouristList.current.code : "";
    },
    getSelectedVisa() {
      return this.$store.state.VisaType.visa_type;
    },
    visas() {
      return this.$store.state.VisaTypeList.all;
    },
    currentCountryName() {
      return this.$store.state.CountryForTouristList.current.country_name;
    },
    stdCode() {
      return this.$store.state.CountryForTouristList.current.std_code;
    },
    currentNationality() {
      return this.$store.state.CountryForTouristList.current.id;
    },
    visa() {
      let v = this.$store.state.VisaSingle.visa;
      if (typeof this.currentNationality !== "undefined")
        v.traveller.country = this.currentNationality;

      return v;
    },
    show_apply_with_travel_document() {
      return this.type !== 'diplomatic-visa' && this.type !== 'official-visa' && this.$route.params.office === 'DoI' && this.apply_type !== 'eta'
    }
  }
};
</script>
